import * as React from "react";
import { Loader2 } from "lucide-react";

import { cn } from "@/lib/utils";

/**
 * Busy indicator for buttons and menu items.
 *
 * Sized to the icon slot of `Button` (`[&_svg]:size-4`), so it can replace an action's own
 * icon while a request is in flight instead of being added next to it - swapping keeps the
 * button's width stable, which appending does not.
 *
 * Mirrors the client app's `components/ui/spinner.tsx`; keep the two in step.
 */
function Spinner({
  className,
  ...props
}: React.ComponentProps<typeof Loader2>) {
  return (
    <Loader2
      role="status"
      aria-label="Loading"
      className={cn("size-4 animate-spin", className)}
      {...props}
    />
  );
}

export { Spinner };
